import { Box, Button, Flex, InfoIcon, Typography } from '@iheartjane/reefer';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useNavigateBack } from '@jane/shared/hooks';

import { Modal, ScanQRIcon } from '../components';
import type { RootLoaderType } from '../data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '../hooks';

export const CheckoutOnDevice = () => {
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing({
    defaultPadSize: 16,
    defaultSize: 24,
  });
  const scanIconSize = isIpad ? '100%' : 440;
  const navigate = useNavigate();
  const goBack = useNavigateBack(`stores/${storeId}/menu`);

  const onShowQr = useCallback(() => {
    navigate(`/stores/${storeId}/reservation/qr`, { replace: true });
  }, [navigate, storeId]);

  return (
    <Modal
      appId="root"
      contentLabel="Checkout"
      onRequestClose={() => goBack()}
      open
      overflow="visible"
      variant="dialogue"
    >
      <Modal.Content padding={false}>
        <Flex flexDirection="column" p={getKioskSpacing(32, 40)} minWidth={480}>
          <Typography variant="header-bold">Ready to checkout?</Typography>
          <Typography mb={defaultSpacing} variant="header-bold">
            Get your phone ready.
          </Typography>
          <Typography mb={24}>
            You'll need your phone to scan the QR code on the next screen. If
            you need help, contact a staff member.
          </Typography>
          <Flex alignSelf="center" alignItems="center" px={24}>
            <ScanQRIcon height={scanIconSize} width={scanIconSize} />
          </Flex>
          <Flex
            alignItems="center"
            background="success-light"
            borderRadius="sm"
            mb={defaultSpacing}
            mt={24}
            p={16}
            width="100%"
          >
            <Box width={24}>
              <InfoIcon size="md" />
            </Box>
            <Typography ml={16}>
              Once the QR code is generated, the bag cannot be modified. Please
              make any changes to your bag before moving on.
            </Typography>
          </Flex>
          <Flex
            alignItems="center"
            justifyContent="center"
            flexDirection="row"
            pt={getKioskSpacing(0, 24)}
          >
            <Button
              full
              mr={defaultSpacing}
              label={
                <Typography
                  color="text-main"
                  variant={`${isIpad ? 'body' : 'section'}-bold`}
                >
                  Cancel
                </Typography>
              }
              onClick={() => goBack()}
              size={isIpad ? 'default' : 'large'}
              variant="tertiary"
            />
            <Button
              full
              label={
                <Typography
                  color="text-info"
                  variant={`${isIpad ? 'body' : 'section'}-bold`}
                >
                  Show QR code
                </Typography>
              }
              onClick={onShowQr}
              size={isIpad ? 'default' : 'large'}
              variant="primary"
            />
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
